import { useState, useCallback } from 'react';
import { getRepositories } from '../api/repositoriesHttpClient';
import { Repository } from '../api/models/Repository';

export const useRepositories = () => {
  const [repositories, setRepositories] = useState<Repository[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchRepositories = useCallback(
    async (projectId: string) => {
      setLoading(true);
      setError(null);
      try {
        const data = await getRepositories(projectId);
        setRepositories(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    repositories,
    loading,
    error,
    fetchRepositories,
  };
};
